<div class="show-small p-3 m-3">
  <div class="fw-bold">{{ formatDate(show.date) }}</div>
  <div>{{ show.location }}</div>
  <div class="mb-2">{{ show.title }}</div>
  <a
    href="{{ show.url }}"
    target="_blank"
    class="col-4 text-center py-2 no-line more-info-btn"
    >More Info</a
  >
</div>
